var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    viewBox: "0 0 71 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.773 17.117C42.19 6.554 35.449 0 35.449 0s-6.754 6.554-17.32 17.117C12.548 22.692 0 36.527 0 50.282c0 9.17 7.435 16.605 16.607 16.605 6.018 0 11.273-3.209 14.186-8.004v.006c.292-.357.77-.651 1.306-.651.857 0 1.634.602 1.545 1.35-.641 4.944-3.426 17.135-14.404 21.252h32.408c-10.976-4.117-13.759-16.308-14.393-21.252-.096-.748.686-1.35 1.54-1.35.526 0 1.012.294 1.306.65l.005-.005c2.899 4.795 8.159 8.004 14.18 8.004 9.163 0 16.606-7.434 16.606-16.605 0-13.755-12.548-27.59-18.12-33.165z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.449 17.15l4.495 13.858H54.52l-11.79 8.566 4.507 13.856-11.788-8.564L23.66 53.43l4.501-13.856-11.794-8.566h14.586L35.45 17.15z",
    fill: "#fff"
  })))));
}
SvgNoData.displayName = 'NoData';
export default SvgNoData;